import { configureStore } from '@reduxjs/toolkit'
import updateToolsInputReducer from "./tools/toolsInput.slice"
import updateToolsOutputReducer from "./tools/toolsOutput.slice"

export const makeStore = () => {
  return configureStore({
    reducer: {
      updateToolsInput: updateToolsInputReducer,
      updateToolsOutput: updateToolsOutputReducer
    }
  })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']